import gCard from "@/components/g-card/g-card.vue"
import router from "@/router"
import axios from "axios"
import { JWTService } from "@/shared/services/jwt.js"

export default {
  name:'Login',
  components:{
    'g-card': gCard
  },

  props: {

  },

  mounted () {

  },
  data () {
    return {
      telaLogin: true,
      telaEsqueciSenha: false,
      mensagem: '', 
      tipo: 'password',
      labelBotao: 'ENTRAR',
      labelBotaoRecuperar: 'RECUPERAR',
      estaCarregando: false,
      tamanhoBotao: '60%',
      login: '',
      email: '',
      senha: ''
    }
  },

  methods: {
    enviarEmail() {
      this.labelBotaoRecuperar = ''
      this.tamanhoBotao = '37px'
      this.estaCarregando = true;
      if(this.email != (null || '')){
        this.axios.post(process.env.VUE_APP_WEB_API + 'ForgotPassword',{
          Login: this.email
        },{}).then(res => {
          if(res.data.autenticado == false) {
            this.$toast.add({severity:'error', summary: 'Erro ao recuperar', detail:res.data.mensagem, life: 4000});
          }
          else if(res.data.autenticado == true){
            this.$toast.add({severity:'success', detail:res.data.mensagem, life: 7000});
            setTimeout(() => {
              this.voltarLogin()
            }, 1500)
          }
        }).finally(()=>
          this.estaCarregando = false,
          this.labelBotaoRecuperar = 'RECUPERAR',
          this.tamanhoBotao = '60%'
        )
      }
      else {
        this.$toast.add({severity:'error', detail:'Por favor preencha o login registrado', life: 4000});
        this.estaCarregando = false
        this.labelBotaoRecuperar = 'RECUPERAR'
        this.tamanhoBotao = '60%'
      }
    },
    voltarLogin() {
      this.email = ''
      this.telaLogin = true
      this.telaEsqueciSenha = false
    },
    esqueciSenha() {
      this.senha = ''
      this.login = ''
      this.telaLogin = false
      this.telaEsqueciSenha = true
    },
    mostrarSenha(){
      if(this.tipo=== 'password'){
        this.tipo = 'text'
      }
      else{
        this.tipo = 'password'
      }
    },

    logar () {
      this.labelBotao = ''
      this.tamanhoBotao = '37px'
      this.estaCarregando = true;
      setTimeout(() => {
        this.axios.post(process.env.VUE_APP_WEB_API + 'Login',{
          Login: this.login,
          Senha: this.senha,
        },{})
            .then(res => {
              this.mensagem = res.data.mensagem
              if (res.data.autenticado) {
                JWTService.SaveToken(res.data.token)
                axios.defaults.headers.common['Authorization'] = `Bearer ${JWTService.GetToken()}`;
                router.push('/dashboard')
              }
              else if(this.mensagem == "Senha vencida! Por favor, faça a alteração.")
              {
                this.$toast.add({severity:'error', summary: 'Erro no login', detail:this.mensagem, life: 4000});
                this.estaCarregando = false
                this.labelBotao = 'ENTRAR'
                this.tamanhoBotao = '60%'
                this.esqueciSenha();
              }
              else if(this.mensagem == "Por favor, troque sua senha.")
                {
                  this.$router.push(`/ChangePasswordFirstAccess/${this.login}`);
                  this.estaCarregando = false
                  this.labelBotao = 'ENTRAR'
                  this.tamanhoBotao = '60%'
                }
              else if(this.mensagem == "Sistema em manutenção!"){
                this.estaCarregando = false
                this.labelBotao = 'ENTRAR'
                this.tamanhoBotao = '60%'
                this.$router.push("/Tapume")
              }
              else{
                this.$toast.add({severity:'error', summary: 'Erro', detail:this.mensagem, life: 4000});
                this.estaCarregando = false
                this.labelBotao = 'ENTRAR'
                this.tamanhoBotao = '60%'
              }

            })
            .catch()
      },1100)
    }
  }
}
